import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  initInstSession,
  accessStorage,
  formatNewDate,
} from '../../spa/components/institutional/common/institutionalConfig.js'
import AlertBanner from '../AlertBanner/AlertBanner.jsx'

class LastLoginElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'last-login-react-app'
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)
    initInstSession()
    const userInfo = accessStorage.getUserInfo()
    if (userInfo?.name && userInfo?.lastLogin?.toString()) {
      const userData = {
        name: userInfo?.fullName || '',
        lastLogin: formatNewDate(userInfo?.lastLogin) || '',
      }
      const container = document.getElementById(reactContainerId)
      const root = createRoot(container)

      root.render(
        <AlertBanner
          status="info"
          sticky={true}
          title={`Welcome, ${userData.name}.`}
          text={`Your last login was ${userData.lastLogin.replaceAll(
            ' , ',
            ', '
          )}`}
          lastLogin={true}
        />
      )
    }
  }
}

customElements.define('last-login', LastLoginElement)
